export var hasParent = function hasParent(element, parent) {
  if (!element) return false;
  if (element === document.body) return parent === document.body;
  if (element === parent) return true;
  return hasParent(element.parentElement, parent);
};
//# sourceMappingURL=hasParent.mjs.map